//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { makeStyles } from "@material-ui/core/styles";

export const Styles = makeStyles((theme) => ({
  searchInput: {
    width: 400,
    borderRadius: 20,
    marginTop: 10,
    "@media (max-width: 600px)": {
      width: "100%",
    },
  },
  searchInputIcon: {
    cursor: "pointer",
  },
  topGrid: {
    // marginBottom: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  yesBtn: {
    backgroundColor: "green",
    padding: "2px 12px",
    borderRadius: 20,
    color: "white",
    fontWeight: "bold",
  },
  noBtn: {
    backgroundColor: "red",
    padding: "2px 12px",
    borderRadius: 20,
    color: "white",
    fontWeight: "bold",
  },
  enrolledBtn: {
    backgroundColor: "grey",
    padding: "2px 12px",
    borderRadius: 20,
    color: "white",
    fontWeight: "bold",
  },
  matchedValue: {
    color: "grey",
    verticalAlign: "middle",
  },
  unMatchedValue: {
    color: "red",
    verticalAlign: "middle",
  },
  filterBtnGrid: {
    "@media (min-width: 600px)": {
      textAlign: "right",
    },
    "@media (max-width: 600px)": {
      padding: 10,
    },
  },
  filterBtn: {
    marginLeft: 20,
    marginTop: 13,
  },
  filterCardDiv: {
    overflowX: "auto",
  },
  filterCard: {
    boxShadow: " 10px 10px 10px #00000029 !important",
    border: " 1px solid #707070",
    borderRadius: "20px !important",
    width: "100%",
    zIndex: 100,
    marginTop: "2%",
  },
  filterCardGridContainer: {
    padding: 15,
    height: "100%",
  },
  filterCardGrid: {
    borderRight: "1px solid #707070",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    "@media (max-width: 600px)": {
      border: "none",
    },
  },
  filterCardHeadText: {
    fontWeight: "bold",
    fontSize: "1rem",
  },
  filterCardSubHeadText: {
    fontSize: 24,
  },
  filterCardInput: {
    borderRadius: 10,
    width: "100%",
  },
  filterCardBtnGrid: {
    textAlign: "center",
    alignSelf: "center",
  },
  filterCardResetBtn: {
    color: "#2F7CBD",
    backgroundColor: "#fff",
    fontSize: "0.875rem",
    border: " 1px solid #2F7CBD",
    borderRadius: 10,
    width: 90,
    height: 40,
    textTransform: "capitalize",
    // marginTop: "13%",
  },
  filterCardApplyBtn: {
    color: "#fff",
    backgroundColor: "#2F7CBD",
    fontSize: "0.875rem",
    border: " 1px solid #2F7CBD",
    borderRadius: 10,
    width: 90,
    height: 40,
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#2F7CBD",
    },
  },
  badge: {
    backgroundColor: "#C52025",
    color: "#fff",
    fontWeight: "bold",
  },
  badges: {
    position: "inherit",
    "@media (max-width: 600px)": {
      marginRight: 15,
    },
  },
  btnDiv: {
    display: 'flex',
    justifyContent: "flex-end"
  },
  createBtn: {
    background: "#0a72ba",
    color: '#fff',
    border: 'none',
    borderRadius: 5,
    fontWeight: 'bold',
    cursor: 'pointer',
    width: 60,
    height: 30
  },
  popupBtnDiv: {
    height: 60,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  submitBtn: {
    border: 'none',
    width: '100px',
    height: '35px',
    background: '#0a72ba',
    color: '#fff',
    margin: "25px 0px 0px 0px",
    cursor: 'pointer',
    borderRadius: 5
  },
  closeIcon: {
    fontSize: 24,
    position: 'absolute',
    top: 5,
    right: 5,
    cursor: 'pointer'
  },
  errorMsg: {
    fontSize: 12,
    color: "red",
    margin: 0,
    padding: 0
  },
  imgInputDiv: {
    backgroundColor: '#d3d3d3',
    // width: '70%',
    height: '50px',
    borderRadius: '5px',
    border: '1px #707070 dashed',
    flexDirection: 'column',
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'center',
    textAlign: 'center',
  },
  imgInput: {
    position: 'absolute',
    width: '350px',
    height: '100px',
    opacity: '0',
    cursor: 'pointer',
    backgroundColor: 'aqua',
  },
  imgBtnUpload: {
    backgroundColor: '#305698',
    borderRadius: '5px',
    border: '1px',
    padding: '5px 20px 5px 20px',
    color: '#fff',
    cursor: 'pointer',
  },
  exportBtn1: {
    
    marginLeft: 79,
    marginTop: 10,

  color: "#fff",
  width: "80px",
  height: "35px",
  fontSize: "14px",
  cursor: "pointer",
  fontFamily: "segoe-ui",
  borderRadius: 5,
  backgroundColor: "#0a72ba",
  border: "none",
 

  "@media (max-width: 600px)": {
    marginTop: "4rem",
  },
},
CSVlink: {
  display: "none",
},

}));
